import { render } from "./ModalAgendarReuniaoProjeto.vue?vue&type=template&id=37f2bdda&scoped=true"
import script from "./ModalAgendarReuniaoProjeto.vue?vue&type=script&lang=js"
export * from "./ModalAgendarReuniaoProjeto.vue?vue&type=script&lang=js"

import "./ModalAgendarReuniaoProjeto.vue?vue&type=style&index=0&id=37f2bdda&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f2bdda"]])

export default __exports__